var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenant-projects" },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            "need-goback": false,
            buttons: _vm.activeBtns,
            title: _vm.tenancyInfoTitle,
            status: _vm.status,
            dotOption: _vm.dotOption,
            lifecycleModal: _vm.lifecycleModal,
            needOpenLifecycle: true,
          },
        },
        [
          _c("template", { slot: "back-button" }, [
            _c(
              "div",
              {
                on: {
                  "!mousedown": function ($event) {
                    return _vm.suppressSubmissionAutosave.apply(null, arguments)
                  },
                },
              },
              [
                _c("HKLHeader", {
                  attrs: {
                    "link-class-left-primary": "link-back-to-tenancy",
                    "label-left-primary":
                      _vm.tenantProjectHeaderLeftPrimaryLabel,
                    "label-left-secondary":
                      _vm.tenantProjectHeaderLeftSecondaryLabel,
                    "label-right-leading": _vm.$t(
                      "listNavigation.previousRecord"
                    ),
                    "label-right-trailing": _vm.$t("listNavigation.nextRecord"),
                    "navigation-entries":
                      _vm.tenantProjectHeaderNavigationEntries,
                    "nav-base-path-hotb": _vm.hotbNavBasePath,
                    "nav-base-path-tenant-project":
                      _vm.tenantProjectNavBasePath,
                    "current-record-id": _vm.tenantProjectHeaderCurrentRecordId,
                    "navigate-prev-enabled": _vm.isUnderBatch
                      ? _vm.canGoToPreviousWorkPermitRecord
                      : undefined,
                    "navigate-next-enabled": _vm.isUnderBatch
                      ? _vm.canGoToNextWorkPermitRecord
                      : undefined,
                  },
                  on: {
                    "left-primary": _vm.onTenantProjectHklLeftPrimary,
                    "left-secondary": _vm.navToAllTenantProjects,
                    "right-leading": _vm.onTenantProjectHklPrevious,
                    "right-trailing": _vm.onTenantProjectHklNext,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("Lifecycle", {
        ref: "tenantProjectLifecycle",
        attrs: {
          modalId: "tenant-project-modules-lifecycle-modal",
          type: "tenantProject",
          histories: _vm.histories,
          commentAttr: _vm.lifecycleCommentAttrs.comments,
          emptyHistoryHint: _vm.emptyHistoryHint,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenant-projects-tabContainer" },
        [
          _c(
            "TabsContainer",
            {
              ref: "tab-container",
              attrs: {
                tabNames: _vm.tabNames,
                getCurrentTab: _vm.getActiveIndex,
                manualTabSelect: true,
              },
              on: {
                tabMousedown: _vm.suppressSubmissionAutosave,
                tabClick: _vm.onTabClick,
              },
            },
            [
              _vm.enableWorkPermitsFeature && _vm.isUnderBatch
                ? _c("template", { slot: "float-right" }, [
                    _c(
                      "i",
                      {
                        staticClass:
                          "batch-review-nav__link show-only-while-sticky-header-on",
                        class: {
                          "batch-review-nav__link--disabled":
                            !_vm.canGoToPreviousWorkPermitRecord,
                        },
                        on: { click: _vm.toPreviousWorkPermit },
                      },
                      [
                        _vm._v(
                          "\n          < " +
                            _vm._s(_vm.$t("listNavigation.previousRecord")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "i",
                      {
                        staticClass:
                          "batch-review-nav__link show-only-while-sticky-header-on",
                        class: {
                          "batch-review-nav__link--disabled":
                            !_vm.canGoToNextWorkPermitRecord,
                        },
                        on: { click: _vm.toNextWorkPermit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("listNavigation.nextRecord")) +
                            " >\n          "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showSubmissionsCommentsPin
                ? _c("template", { slot: "label-1" }, [
                    _c(
                      "span",
                      {
                        staticClass: "tenant-projects__submissions-tab-label",
                        class: {
                          "tenant-projects__submissions-tab-label--single-line":
                            !_vm.submissionsTabLabelParts.second,
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "tenant-projects__submissions-tab-line tenant-projects__submissions-tab-line--primary",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionsTabLabelParts.first) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "tenant-projects__submissions-tab-pin-cell",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "pin__bubble-orange tenant-projects__tab-pin",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-thumb-tack",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.submissionsTabLabelParts.second
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "tenant-projects__submissions-tab-line tenant-projects__submissions-tab-line--secondary",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.submissionsTabLabelParts.second
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("ProjectInformation", {
                ref: "projectInformation",
                attrs: {
                  slot: "tab-0",
                  setHeaderBtn: _vm.setHeaderBtn,
                  canEdit: _vm.canEdit,
                },
                slot: "tab-0",
              }),
              _vm._v(" "),
              _c("SubmissionsEntry", {
                attrs: { slot: "tab-1" },
                slot: "tab-1",
              }),
              _vm._v(" "),
              _vm.enableWorkPermitsFeature
                ? _c("ContractorInfo", {
                    ref: "contractorInfo",
                    attrs: { slot: "tab-2" },
                    slot: "tab-2",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.enableWorkPermitsFeature
                ? _c("WorkPermitView", {
                    ref: "work-permit-view",
                    attrs: { slot: "tab-3" },
                    slot: "tab-3",
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ProjectControl", {
                ref: "ProjectControl",
                attrs: { slot: "" + ("tab-" + (_vm.tabNames.length - 1)) },
                slot: "" + ("tab-" + (_vm.tabNames.length - 1)),
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "DialogSlot",
        {
          ref: "proj-ops-modal",
          attrs: {
            id: "tenant-project-status-dialog",
            beforeCloseModal: _vm.beforeCloseModal,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("span", { class: { "required-flag": _vm.addComment } }, [
                _vm._v(_vm._s(_vm.projectActionHint)),
              ]),
              _vm._v(" "),
              _vm.addComment
                ? _c("TextField", {
                    staticClass: "withDraw",
                    attrs: {
                      required: "",
                      value: _vm.withdrawComment,
                      placeholder: _vm.$t("hint.withDrawReason"),
                    },
                    on: {
                      updateValue: function (val) {
                        return (_vm.withdrawComment = val)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
            _c(
              "button",
              {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                staticClass: "btn btn--orange close-reveal-modal",
                attrs: { type: "button" },
                on: { click: _vm.exeOperate },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.addComment
                        ? _vm.$t("action.confirmWithdraw")
                        : _vm.$t("action.yesContinue")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }